import {createSvgIcon} from '../create-svg-icon';

export const AlignVerticalTopIcon = createSvgIcon(
  <path d="M22 2v2H2V2h20zM7 22h3V6H7v16zm7-6h3V6h-3v10z" />
, 'AlignVerticalTopOutlined');
